import React from 'react';
import AdvancedSelfAssessment from './AdvancedSelfAssessment.js';

const SelfAssessment = () => {
  return <AdvancedSelfAssessment />;
};

export default SelfAssessment;
